
































































import UUIFComponent from '@/shared/uuifComponent';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { InfoState } from '@/core';
// import { InfoState } from '@/core';

const cssPrefix = 'update-zero-touch';

@Component({
  components: {
    ...UUIFComponent,
  },
})
export default class UpdateZeroTouch extends SwExtendedVue {
  cssPrefix = cssPrefix;
  statusChanged: boolean = false;

  @Prop({ default: [] })
  selectedProducts: any[];
  localCopySelectedProducts: any[] = [];
  mounted() {
    this.statusChanged = false;
    this.localCopySelectedProducts = JSON.parse(JSON.stringify(this.selectedProducts));
    if (this.localCopySelectedProducts.length === 1) {
      this.$store.dispatch('MswProductsStoreModule/getProductDetail', this.localCopySelectedProducts[0].serNo)
        .then((resp: any) => {
          this.$store.commit('stopLoading');
          this.localCopySelectedProducts[0].ztValue = (resp.content.pDetail[0].ztValue && resp.content.pDetail[0].ztValue === '1') ? true : false;
        })
        .catch((err: any) => {
          this.$store.commit('stopLoading');
          console.warn(err);
        });
    }
  }

  get selectedProductsMapped() {
    this.localCopySelectedProducts.forEach((item, i) => {
      this.localCopySelectedProducts[i].ztValue = (item.ztValue === '1' || item.ztValue === true);
    });
    return this.localCopySelectedProducts;
  }

  update() {
    const changeList: any[] = [];
    this.localCopySelectedProducts.forEach((product) => {
      const entry = {
        ztvalue: product.ztValue ? 1 : 0,
        datacenter: product.userdefaultdc,
        serialnumber: product.serNo,
        nonztvalue: '',
      };
      changeList.push(entry);
    });
    this.$store.commit('startLoading');
    this.$store.dispatch('MswProductsStoreModule/updateZtMultiple', { ztinputrequest : changeList })
    .then((res) => {
      if (res.msgCode === 'MSWAPP:SUCCESS') {
        this.statusChanged = true;
        const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
      } else {
        this.localCopySelectedProducts = this.selectedProducts;
        const message: InfoState = { infoType: 'high', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
      this.$store.commit('stopLoading');
      this.close();
    });
  }

  ztValueOfProduct(ztValue: number) {
    return ztValue === 1;
  }

  close() {
    this.$emit('request-close');
    if (this.statusChanged) this.$emit('ztstatus-changed');
  }
}
